import { AssetReturnType } from "../../types.js";

export function getAssetActualSize(asset: AssetReturnType) {
  if (asset.width && asset.height) {
    return {
      actualWidth: asset.width,
      actualHeight: asset.height,
    };
  }
  return { actualWidth: 0, actualHeight: 0 };
}
